import { observable, computed, toJS } from "mobx";

class ProfilePhotosStore {
	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this._media = staticContext.provider?.media;
	}

	@observable _media = [];
	@computed get media() {
		return toJS(this._media);
	}

	set media(media) {
		this._media = media;
	}

	hidePicturesVideos(provider) {
		return (
			provider.track?.source?.toLowerCase() === "savvy" && !provider?.claimed
		);
	}
}

export default ProfilePhotosStore;
